import { getCookies } from "../helpers/commonFunctions";

export default async function getHeaders(authToken : string) {
  const cookiesData = getCookies();

  //   const token = await generateToken();
  // const token = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhdDAiOjE3MDEwMDI1MzgsImF1ZCI6ImRlc2t0b3AiLCJzdWIiOjY4NjU5MDUyLCJybmQiOiI1MTUxMzgxMSIsImV4cCI6MTcwMTAwMjg3NH0.qOV587dKYrOCgl9vNLe0BE49wvcSJW5HxR98er01im0";
  const token = authToken;
  const defaultHeaders = {
    source: "desktop",
    "accept-language": cookiesData.NEXT_LOCALE ?? "ar",
    "session-id": cookiesData.userInfo.id,
    country: cookiesData.ecountry ?? "jo",
    "x-tracking-uuid": cookiesData.device_uuid,
    "Content-Type": "application/json",
  };

  return {
    ...(token
      ? {
          Authorization: "Bearer " + token,
        }
      : {}),
    ...defaultHeaders,
  };
}
